
export const GAMIFICATION_ENTITY_TYPE = "GAMIFICATION_CAMPAIGN";

export interface IGamificationAuditFieldChange {
  field: string;
  from?: unknown;
  to?: unknown;
}

export interface IGamificationAuditEvent {
  id: number;
  entity_type: string;
  entity_id: string;
  event_type: string;
  event_payload?: {
    message?: string;
    action?: string;
    changes?: IGamificationAuditFieldChange[];
    fieldsUpdated?: string[];
    campaignId?: number | string;
    storeCode?: number | string;
    [key: string]: unknown;
  };
  action: string;
  email: string;
  ip?: string;
  method?: string;
  information?: string;
  status?: string;
  created_at: string;
}

export interface IGamificationAuditResponse {
  entity_type: string;
  entity_id: string;
  total: number;
  events: IGamificationAuditEvent[];
}
